import { render, staticRenderFns } from "./ContestEntryFormContestAside.vue?vue&type=template&id=587f0d39&scoped=true"
import script from "./ContestEntryFormContestAside.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContestEntryFormContestAside.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ContestEntryFormContestAside.vue?vue&type=style&index=0&id=587f0d39&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587f0d39",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('587f0d39')) {
      api.createRecord('587f0d39', component.options)
    } else {
      api.reload('587f0d39', component.options)
    }
    module.hot.accept("./ContestEntryFormContestAside.vue?vue&type=template&id=587f0d39&scoped=true", function () {
      api.rerender('587f0d39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/event/ContestEntryFormContestAside.vue"
export default component.exports